import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const MODULO = "MiPerfil";

const normalizarTexto = (texto = "") =>
  String(texto)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();

const Mi_Perfil = () => {
  const navigate = useNavigate();

  const [instructor, setInstructor] = useState(null);
  const [loading, setLoading] = useState(false);

  const colores = {
    fondo: "linear-gradient(135deg, #0e1319 0%, #212529 40%, #0d6efd 100%)",
    azul: "#0d6efd",
  };

  const getHeaders = () => {
    const token =
      localStorage.getItem("token") || sessionStorage.getItem("token");

    return {
      Authorization: `Bearer ${token}`,
    };
  };

  const getModuloMiPerfil = () => {
    try {
      const permisosStorage = localStorage.getItem("permisos");
      const usuarioStorage = localStorage.getItem("usuario");
      const userStorage = localStorage.getItem("user");
      const usuariosStorage = localStorage.getItem("usuarios");

      const permisosData = permisosStorage
        ? JSON.parse(permisosStorage)
        : usuarioStorage
          ? JSON.parse(usuarioStorage)
          : userStorage
            ? JSON.parse(userStorage)
            : usuariosStorage
              ? JSON.parse(usuariosStorage)
              : {};

      const modulos = Array.isArray(permisosData)
        ? permisosData
        : permisosData?.modulos ||
        permisosData?.permisos ||
        permisosData?.usuario?.modulos ||
        permisosData?.usuario?.permisos ||
        permisosData?.user?.modulos ||
        permisosData?.user?.permisos ||
        [];

      const moduloBuscado = normalizarTexto(MODULO);

      return (
        modulos.find((modulo) => {
          const nombre =
            modulo?.nombreModulo || modulo?.modulo || modulo?.nombre || "";

          return normalizarTexto(nombre) === moduloBuscado;
        }) || {}
      );
    } catch (error) {
      console.error("Error leyendo permisos MiPerfil:", error);
      return {};
    }
  };

  const moduloMiPerfil = useMemo(() => getModuloMiPerfil(), []);

  const puedeLeer =
    moduloMiPerfil?.puedeLeer === true ||
    moduloMiPerfil?.leer === true ||
    moduloMiPerfil?.read === true;

  const puedeActualizar =
    moduloMiPerfil?.puedeActualizar === true ||
    moduloMiPerfil?.actualizar === true ||
    moduloMiPerfil?.editar === true ||
    moduloMiPerfil?.update === true;

  const nombreCompleto = [
    instructor?.nombre1Instructor,
    instructor?.nombre2Instructor,
    instructor?.apellido1Instructor,
    instructor?.apellido2Instructor,
  ]
    .filter(Boolean)
    .join(" ");

  const cargarPerfil = async () => {
    try {
      if (!puedeLeer) {
        return;
      }

      setLoading(true);

      const { data } = await axios.get("/api/perfil", {
        headers: getHeaders(),
      });

      if (!data?.ok) {
        Swal.fire(
          "Perfil no encontrado",
          data?.message || "No se encontró información del perfil.",
          "warning"
        );
        return;
      }

      setInstructor(data.message || {});
    } catch (error) {
      console.error(
        "Error al cargar perfil:",
        error.response?.data || error.message
      );

      if (error.response?.status === 401) {
        Swal.fire("Sesión expirada", "Ingrese nuevamente.", "warning");
        localStorage.clear();
        sessionStorage.clear();
        navigate("/");
        return;
      }

      Swal.fire(
        "Error",
        error.response?.data?.message || "No se pudo cargar el perfil.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargarPerfil();
  }, [puedeLeer]);

  if (!puedeLeer) {
    return (
      <div className="container py-5">
        <div className="alert alert-warning text-center rounded-4">
          No tiene permisos para ver Mi Perfil.
        </div>

        <div className="text-center">
          <button
            className="btn btn-dark mt-3"
            onClick={() => navigate("/inicio")}
          >
            Volver al inicio
          </button>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center bg-body-tertiary">
        <div className="text-center">
          <div className="spinner-border text-dark" />
          <p className="mt-3 text-secondary">
            Cargando perfil del instructor...
          </p>
        </div>
      </div>
    );
  }

  if (!instructor) {
    return (
      <div className="container py-5">
        <div className="alert alert-warning text-center rounded-4">
          No se encontró información del perfil.
        </div>
      </div>
    );
  }

  return (
    <div className="bg-body-tertiary min-vh-100 py-4">
      <div className="container-fluid px-2 px-md-4">
        <div
          className="rounded-4 shadow-sm p-4 mb-4 text-white"
          style={{ background: colores.fondo }}
        >
          <div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
            <div>
              <span className="badge bg-white text-dark rounded-pill px-3 py-2 mb-3">
                Perfil institucional
              </span>

              <h2 className="fw-bold mb-1">
                {nombreCompleto || "Instructor"}
              </h2>

              <p className="mb-0 opacity-75">
                {instructor.emailInstructor || "Sin correo registrado"}
              </p>
            </div>

            <button
              className="btn btn-outline-light fw-semibold"
              onClick={() => navigate(-1)}
            >
              <i className="fa-solid fa-arrow-left me-2"></i>
              Volver
            </button>
          </div>
        </div>

        <div className="row g-4">
          <div className="col-12 col-xl-4">
            <div className="bg-white border rounded-4 shadow-sm overflow-hidden">
              <div className="p-4 text-center border-bottom">
                <div
                  className="mx-auto rounded-circle overflow-hidden shadow"
                  style={{
                    width: 210,
                    height: 210,
                    border: `5px solid ${colores.azul}`,
                    background: "#f8f9fa",
                  }}
                >
                  {instructor.imgInstructor ? (
                    <img
                      src={instructor.imgInstructor}
                      alt="Instructor"
                      className="w-100 h-100"
                      style={{ objectFit: "cover" }}
                    />
                  ) : (
                    <div className="h-100 d-flex align-items-center justify-content-center text-secondary">
                      <i className="fa-solid fa-user-tie fs-1"></i>
                    </div>
                  )}
                </div>

                <h4 className="fw-bold mt-3 mb-1">
                  {nombreCompleto || "Instructor"}
                </h4>

                <p className="text-secondary mb-2">
                  {instructor.emailInstructor || "Sin correo registrado"}
                </p>

                <span
                  className="badge rounded-pill px-3 py-2"
                  style={{ background: colores.fondo, color: "#fff" }}
                >
                  <i className="fa-solid fa-user-graduate me-2"></i>
                  {instructor.rolObjectId?.nombreRol || "Instructor"}
                </span>
              </div>

              <div className="p-4">
                <InfoMini
                  icon="fa-envelope"
                  label="Correo"
                  value={instructor.emailInstructor}
                />

                <InfoMini
                  icon="fa-phone"
                  label="Teléfono"
                  value={instructor.telefono1Instructor}
                />

                <InfoMini
                  icon="fa-id-card"
                  label="Documento"
                  value={instructor.documentoInstructor}
                />

                <InfoMini
                  icon="fa-location-dot"
                  label="Ciudad"
                  value={instructor.ciudadInstructor}
                />
              </div>
            </div>

            <div className="bg-white border rounded-4 shadow-sm p-3 p-md-4 mt-4">
              <h5 className="fw-bold mb-3" style={{ color: colores.azul }}>
                Accesos rápidos
              </h5>

              <div className="row g-3">
                {puedeActualizar && (
                  <AccesoCard
                    icon="fa-user-pen"
                    title="Editar"
                    text="Actualizar perfil"
                    onClick={() => navigate(`/perfil/editar/${instructor._id}`)}
                  />
                )}

                <AccesoCard
                  icon="fa-file-contract"
                  title="Contratos"
                  text="Ver contratos"
                  onClick={() =>
                    navigate(`/instructor/listarcontratos/${instructor._id}`)
                  }
                />

               

                <AccesoCard
                  icon="fa-signature"
                  title="Firma"
                  text="Actualizar firma"
                  onClick={() =>
                    navigate(`/instructor/registrarfirma/${instructor._id}`)
                  }
                />

                <AccesoCard
                  icon="fa-house"
                  title="Inicio"
                  text="Ir al inicio"
                  onClick={() => navigate("/inicio")}
                />
              </div>
            </div>
          </div>

          <div className="col-12 col-xl-8">
            <div className="row g-3 mb-4">
              <ResumenCard
                icon="fa-user"
                title="Identificación"
                value={instructor.tipodocumentoInstructor || "N/A"}
              />

              <ResumenCard
                icon="fa-droplet"
                title="Grupo RH"
                value={instructor.rhInstructor || "N/A"}
              />

              <ResumenCard
                icon="fa-cake-candles"
                title="Edad"
                value={instructor.edadInstructor || "N/A"}
              />
            </div>

            <Seccion
              titulo="Datos personales"
              icono="fa-address-card"
              color={colores.azul}
            >
              <Campo label="Primer nombre" value={instructor.nombre1Instructor} />
              <Campo label="Segundo nombre" value={instructor.nombre2Instructor} />
              <Campo label="Primer apellido" value={instructor.apellido1Instructor} />
              <Campo label="Segundo apellido" value={instructor.apellido2Instructor} />
              <Campo label="Tipo documento" value={instructor.tipodocumentoInstructor} />
              <Campo label="Documento" value={instructor.documentoInstructor} />
              <Campo
                label="Fecha nacimiento"
                value={formatearFecha(instructor.fechanacimientoInstructor)}
              />
              <Campo label="Sexo" value={instructor.sexoInstructor} />
              <Campo label="RH" value={instructor.rhInstructor} />
            </Seccion>

            <Seccion
              titulo="Contacto y ubicación"
              icono="fa-map-location-dot"
              color={colores.azul}
            >
              <Campo
                label="Correo electrónico"
                value={instructor.emailInstructor}
              />

              <Campo
                label="Teléfono principal"
                value={instructor.telefono1Instructor}
              />

              <Campo
                label="Teléfono alterno"
                value={instructor.telefono2Instructor}
              />

              <Campo label="Dirección" value={instructor.direccionInstructor} />
              <Campo label="País" value={instructor.paisInstructor} />

              <Campo
                label="Departamento / Estado"
                value={instructor.estadoInstructor}
              />

              <Campo label="Ciudad" value={instructor.ciudadInstructor} />

              <Campo
                label="Rol asignado"
                value={instructor.rolObjectId?.nombreRol}
              />
            </Seccion>
          </div>
        </div>
      </div>
    </div>
  );
};

const AccesoCard = ({ icon, title, text, onClick }) => (
  <div className="col-6">
    <button
      type="button"
      className="w-100 h-100 border rounded-4 bg-white shadow-sm p-3 text-center"
      onClick={onClick}
      style={{
        cursor: "pointer",
        transition: "all 0.2s ease-in-out",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-3px)";
        e.currentTarget.style.borderColor = "#0d6efd";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.borderColor = "";
      }}
    >
      <i
        className={`fa-solid ${icon} fs-3 mb-2`}
        style={{ color: "#0d6efd" }}
      ></i>

      <div className="fw-bold text-dark">{title}</div>
      <small className="text-secondary">{text}</small>
    </button>
  </div>
);

const Seccion = ({ titulo, icono, children, color }) => (
  <div className="bg-white border rounded-4 shadow-sm p-3 p-md-4 mb-4">
    <div className="d-flex align-items-center gap-2 mb-3">
      <div
        className="rounded-circle d-flex align-items-center justify-content-center text-white"
        style={{
          width: 38,
          height: 38,
          backgroundColor: color,
        }}
      >
        <i className={`fa-solid ${icono}`}></i>
      </div>

      <h5 className="fw-bold mb-0" style={{ color }}>
        {titulo}
      </h5>
    </div>

    <hr />

    <div className="row g-3">{children}</div>
  </div>
);

const Campo = ({ label, value }) => (
  <div className="col-12 col-md-6 col-xl-4">
    <div className="border rounded-4 p-3 h-100 bg-light">
      <div className="small text-secondary text-uppercase fw-semibold mb-1">
        {label}
      </div>

      <div className="fw-bold text-dark">{value || "No registrado"}</div>
    </div>
  </div>
);

const InfoMini = ({ icon, label, value }) => (
  <div className="d-flex align-items-center gap-3 mb-3">
    <div
      className="rounded-circle bg-light border d-flex align-items-center justify-content-center"
      style={{ width: 42, height: 42 }}
    >
      <i className={`fa-solid ${icon} text-dark`}></i>
    </div>

    <div className="text-start">
      <div className="small text-secondary">{label}</div>
      <div className="fw-semibold">{value || "No registrado"}</div>
    </div>
  </div>
);

const ResumenCard = ({ icon, title, value }) => (
  <div className="col-12 col-md-4">
    <div className="bg-white border rounded-4 shadow-sm p-3 h-100">
      <div className="d-flex align-items-center gap-3">
        <div
          className="rounded-4 text-white d-flex align-items-center justify-content-center"
          style={{
            width: 52,
            height: 52,
            background: "linear-gradient(135deg, #212529 0%, #0d6efd 100%)",
          }}
        >
          <i className={`fa-solid ${icon}`}></i>
        </div>

        <div>
          <div className="small text-secondary">{title}</div>
          <div className="fw-bold fs-5">{value}</div>
        </div>
      </div>
    </div>
  </div>
);

const formatearFecha = (fecha) => {
  if (!fecha) return "";
  return new Date(fecha).toLocaleDateString("es-CO");
};

export default Mi_Perfil;